/**
 * Extract a location keyword from article tags.
 * Shared across Top10Guides and RealReviews to avoid duplication.
 */
const LOCATION_KEYWORDS = [
  "台北", "台中", "台南", "高雄", "新北", "桃園", "基隆",
  "宜蘭", "屏東", "澎湖", "小琉球", "綠島", "東京", "全台", "日本",
];

export function extractLocation(tags: string[]): string {
  for (const tag of tags) {
    for (const loc of LOCATION_KEYWORDS) {
      if (tag.includes(loc)) return loc;
    }
  }
  return "全台";
}